var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form",
        [
          _vm.arquivosFinanceiros.length > 0
            ? _c(
                "fieldset-component",
                { attrs: { title: "Arquivos Financeiros", collapsed: false } },
                [
                  _c("div", { attrs: { slot: "rows" }, slot: "rows" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-12" }, [
                        _c(
                          "div",
                          { staticClass: "arquivos-financeiros-section" },
                          _vm._l(_vm.arquivosFinanceiros, function (arquivo) {
                            return _c(
                              "div",
                              { key: arquivo.id, staticClass: "receitasLista" },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.formatarTextoArquivo(arquivo)) +
                                    "\n                                "
                                ),
                                _c(
                                  "a",
                                  {
                                    staticClass: "btnAcaoUp1",
                                    on: {
                                      click: function ($event) {
                                        _vm.onVisualizarArquivo(arquivo)
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "fa fa-eye" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "btnAcaoUp2",
                                    on: {
                                      click: function ($event) {
                                        _vm.onDownloadArquivo(arquivo)
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "fa fa-download" })]
                                ),
                              ]
                            )
                          })
                        ),
                      ]),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "fieldset-component",
            { attrs: { title: "DADOS DA VENDA", collapsed: false } },
            [
              _c("div", { attrs: { slot: "rows" }, slot: "rows" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-12" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.errors.first("tipoVenda"),
                            expression: "errors.first('tipoVenda')",
                          },
                        ],
                        staticClass: "form-group",
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: {
                              for: "tipoVenda",
                              title: _vm.$t("__.obrigatorio"),
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "__.Components.parent.venda.vendaForm_vue_html.tipoVenda"
                                  )
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("combo-component", {
                          attrs: {
                            id: "tipoVenda",
                            name: "tipoVenda",
                            disabled: true,
                            data: _vm.tipoVendaOptions,
                          },
                          model: {
                            value: _vm.tipoVenda,
                            callback: function ($$v) {
                              _vm.tipoVenda = $$v
                            },
                            expression: "tipoVenda",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.vendafaturada && _vm.model.lancamentosVinculados.length > 0
            ? _c(
                "fieldset-component",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: {
                    title: _vm.$t(
                      "__.Components.parent.venda.pagamento_vue_html.caixa"
                    ),
                    collapsed: false,
                  },
                },
                [
                  _c("div", { attrs: { slot: "rows" }, slot: "rows" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-4" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "dataHoraAbertura" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Components.parent.venda.pagamento_vue_html.dtAberturaCaixa"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.dataHoraAbertura,
                                expression: "dataHoraAbertura",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              id: "dataHoraAbertura",
                              name: "dataHoraAbertura",
                              disabled: "",
                            },
                            domProps: { value: _vm.dataHoraAbertura },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.dataHoraAbertura = $event.target.value
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-4" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "dataHoraFechamento" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Components.parent.venda.pagamento_vue_html.dtFechamentoCaixa"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.dataHoraFechamento,
                                expression: "dataHoraFechamento",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              id: "dataHoraFechamento",
                              name: "dataHoraFechamento",
                              disabled: "",
                            },
                            domProps: { value: _vm.dataHoraFechamento },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.dataHoraFechamento = $event.target.value
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-4" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "nomeUsuario" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Components.parent.venda.pagamento_vue_html.nomeOperadorCaixa"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.nomeUsuario,
                                expression: "nomeUsuario",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              id: "nomeUsuario",
                              name: "nomeUsuario",
                              disabled: "",
                            },
                            domProps: { value: _vm.nomeUsuario },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.nomeUsuario = $event.target.value
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-12" },
        [
          !_vm.isConsulta &&
          _vm.situacaoVenda != 6 &&
          _vm.situacaoVenda != 5 &&
          _vm.model.lancamentosVinculados.length > 0
            ? _c("buttonScComponent", {
                staticStyle: { margin: "10px", "margin-left": "0px" },
                attrs: {
                  classButton: "btn btn-primary",
                  classIcon: "fa fa-plus-circle",
                  buttonName: _vm.$t(
                    "__.Components.parent.venda.financeiro.financeiro_vue_html.addParcela"
                  ),
                },
                on: { click: _vm.showAddParcela },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isConsulta &&
          _vm.situacaoVenda != 6 &&
          _vm.situacaoVenda != 5 &&
          _vm.model.lancamentosVinculados.length == 0
            ? _c("buttonScComponent", {
                staticStyle: { margin: "10px", "margin-left": "0px" },
                attrs: {
                  classButton: "btn btn-primary",
                  classIcon: "fa fa-plus-circle",
                  buttonName: _vm.$t(
                    "__.Components.parent.venda.financeiro.financeiro_vue_html.addRecebimento"
                  ),
                },
                on: { click: _vm.showAddRecebimento },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-12" },
        [
          _vm.model.lancamentosVinculados.length > 0
            ? _c("grid-component", {
                attrs: {
                  data: _vm.gridData,
                  columns: _vm.gridColumnsParcelas,
                  subColumns: _vm.gridColumnsRecebimentos,
                  subDataName: "movimentacoes",
                  showExpand: _vm.model.lancamentosVinculados.length > 0,
                  conditionShowSubData: _vm.conditionShowSubData,
                  showActionColumn: !_vm.isConsulta,
                  showRemoveItem:
                    _vm.model.lancamentosVinculados.length > 0 &&
                    _vm.situacaoVenda != 6 &&
                    _vm.situacaoVenda != 5,
                  showEditItem:
                    _vm.model.lancamentosVinculados.length > 0 &&
                    _vm.situacaoVenda != 6 &&
                    _vm.situacaoVenda != 5,
                  showTableHead: false,
                  showTableFoot: false,
                  showSortIcons: false,
                  extraActions: _vm.extraActions,
                },
                on: {
                  "remove-item": _vm.onRemove,
                  "edit-item": _vm.onEdit,
                  "extra-action": _vm.onExtraActions,
                },
              })
            : _c("recebimento-component", {
                ref: "recebimentoComponent",
                attrs: {
                  permiteRemover: _vm.permiteRemover,
                  showFieldSet: false,
                },
                on: { "remove-pagamento": _vm.onRemovePagamentoRecebimento },
              }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "shortcutComponent",
        {
          ref: "shortcutComponentParcela",
          attrs: { modalClass: "lm-modal" },
          on: {
            "selection-item": _vm.onAddParcela,
            "hide-click": _vm.hideAddParcela,
          },
        },
        [
          _c(
            "div",
            { attrs: { slot: "component" }, slot: "component" },
            [_c("parcela-component", { ref: "parcelaComponent" })],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "shortcutComponent",
        {
          ref: "shortcutComponentRecebimento",
          attrs: { modalClass: "lw-modal" },
          on: { "selection-item": _vm.onAddRecebimento },
        },
        [
          _c(
            "div",
            { attrs: { slot: "component" }, slot: "component" },
            [
              _c("pagamento-component", {
                ref: "pagamentoComponent",
                attrs: { showIncluirRecebimento: false },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }